import { CESesMessageAttributesBase } from './ce-ses-message-attributes-base'


export class CESesMessageAttributes extends CESesMessageAttributesBase {

}